<template>
  <m-dropdown
    block
    placement="bottomRight"
    :relocate-key="referenceLines.length"
    :title="$t('gridPageChartEditor.referenceLines')"
  >
    <m-card-item icon="minus">
      {{ $t('gridPageChartEditor.referenceLines') }}
      <template #right>
        <chart-editor-setting-value :value="referenceLines.length > 0 ? `${referenceLines.length}` : ''" />
      </template>
    </m-card-item>
    <template #overlay>
      <m-card
        padding-xs
        :style="{ minWidth: '30rem', display: 'block' }"
      >
        <div
          v-for="(line, index) in referenceLines"
          :key="index"
          class="_reference-line"
        >
          <m-btn
            icon="delete"
            hide-border
            light
            small
            fab
            class="_reference-line-delete"
            @click="$emit('remove', index)"
          />
          <m-form-item
            :label="$t('gridPageChartEditor.referenceLine.value')"
            compact
          >
            <m-text-field
              :value="line.value != null ? String(line.value) : ''"
              type="number"
              full-width
              @update:value="line.value = $event"
            />
          </m-form-item>
          <m-form-item
            :label="$t('gridPageChartEditor.referenceLine.label')"
            compact
          >
            <m-text-field
              :value="line.label ?? ''"
              full-width
              @update:value="line.label = $event"
            />
          </m-form-item>
          <m-card-item
            class="_reference-line-style-selector"
            @click="$refs[`styleSelect${index}`][0].show()"
          >
            {{ $t('gridPageChartEditor.referenceLine.style') }}
            <template #right>
              <m-select
                :ref="`styleSelect${index}`"
                :value="line.style"
                :items="styleOptions"
                light
                arrow-type="right"
                hide-border
                hide-hover
                @update:value="line.style = $event"
              />
            </template>
          </m-card-item>
          <m-card-item
            class="_reference-line-color-selector"
            @click="$refs[`colorPicker${index}`][0].open()"
          >
            {{ $t('gridPageChartEditor.referenceLine.color') }}
            <template #right>
              <color-picker
                :ref="`colorPicker${index}`"
                :value="line.color"
                shade="darken1"
                hide-border
                hide-hover
                full-width
                @update:value="line.color = $event"
              />
            </template>
          </m-card-item>
        </div>
        <p
          v-if="referenceLines.length === 0"
          class="_reference-line-description"
        >
          {{ $t('gridPageChartEditor.referenceLine.description') }}
        </p>
        <m-btn
          icon="plus"
          :small="referenceLines.length > 0"
          block
          :color="referenceLines.length === 0 ? 'primary' : undefined"
          @click="$emit('add')"
        >
          {{ $t('gridPageChartEditor.addReferenceLine') }}
        </m-btn>
      </m-card>
    </template>
  </m-dropdown>
</template>

<script setup>
import ChartEditorSettingValue from '@/components/custom-grid/ChartEditorSettingValue.vue';
import ColorPicker from '@/components/ColorPicker.vue';

defineProps({
  referenceLines: {
    type: Array,
    required: true,
  },
  styleOptions: {
    type: Array,
    required: true,
  },
});

defineEmits(['add', 'remove']);
</script>

<style scoped lang="scss">
._reference-line-description {
  font-size: 1.2rem;
  color: $font-color-secondary;
  margin-bottom: 1.2rem;
  max-width: 30rem;
  text-align: center;
}

._reference-line {
  position: relative;
  margin-bottom: 1rem;
  padding: 2rem 1.2rem 1.2rem 1.2rem;
  background-color: map_get($grey, 'lighten-7');
  border-radius: .6rem;

  ._reference-line-delete {
    position: absolute;
    top: .8rem;
    right: .8rem;
  }

  ._reference-line-style-selector {
    padding: 0;
  }

  ._reference-line-color-selector {
    padding: 0;
  }
}
</style>
